/**
 * Assembly Type Configuration Section Component
 * Displays dynamic configuration fields based on the selected assembly type
 */

import React from 'react';
import {
  Grid,
  TextField,
  Typography,
  Box,
  CircularProgress,
  Divider,
  Paper
} from '@mui/material';

const AssemblyTypeConfigurationSection = ({
  formData,
  assemblyTypeConfig,
  configLoading,
  getConfigValue,
  handleConfigValueChange
}) => {
  if (!formData.type) {
    return null;
  }
  const hasTypeConfig = assemblyTypeConfig && assemblyTypeConfig.columns && assemblyTypeConfig.columns.length > 0;
  if (!configLoading && !hasTypeConfig) {
    return null;
  }

  return (
    <>
      <Grid item xs={12}>
        <Divider sx={{ my: 2 }} />
      </Grid>
      <Grid item xs={12}>
        <Paper variant="outlined" sx={{ p: 2, border: '1px solid', borderColor: 'divider' }}>
          <Typography variant="h6" sx={{ mb: 2, fontSize: '16px', fontWeight: 600 }}>
            Assembly Type Configuration
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Master-defined columns for this assembly type. Enter assembly and airframe values at installation.
          </Typography>
          {configLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
              <CircularProgress size={24} />
            </Box>
          ) : assemblyTypeConfig && assemblyTypeConfig.columns ? (
            <>
              {assemblyTypeConfig.columns
                .sort((a, b) => a.order - b.order)
                .map((column) => (
                  <Grid container spacing={2} key={column.name} sx={{ mb: 2 }}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label={`${column.label} (Assembly Value)${column.required ? ' *' : ''}`}
                        value={getConfigValue(column.name, 'assemblyValue')}
                        onChange={(e) => handleConfigValueChange(column.name, 'assemblyValue', e.target.value)}
                        required={column.required}
                        type={column.type === 'number' ? 'number' : column.type === 'date' ? 'date' : column.type === 'time' ? 'time' : 'text'}
                        InputLabelProps={column.type === 'date' || column.type === 'time' ? { shrink: true } : undefined}
                        helperText={column.unit ? `Unit: ${column.unit}` : undefined}
                        sx={{ mb: 1 }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label={`${column.label} (Airframe Value)${column.required ? ' *' : ''}`}
                        value={getConfigValue(column.name, 'airframeValue')}
                        onChange={(e) => handleConfigValueChange(column.name, 'airframeValue', e.target.value)}
                        required={column.required}
                        type={column.type === 'number' ? 'number' : column.type === 'date' ? 'date' : column.type === 'time' ? 'time' : 'text'}
                        InputLabelProps={column.type === 'date' || column.type === 'time' ? { shrink: true } : undefined}
                        helperText={column.unit ? `Unit: ${column.unit}` : undefined}
                        sx={{ mb: 1 }}
                      />
                    </Grid>
                  </Grid>
                ))}
            </>
          ) : null}
        </Paper>
      </Grid>
    </>
  );
};

export default AssemblyTypeConfigurationSection;
